export const BROWSER_ID_STORAGE_KEY = 'n8n-browserId';
